import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ApiConstants } from 'src/app/core/constants/api-path.constants';
import { AppConstants } from 'src/app/core/constants/appconstants';
import { ApiService } from 'src/app/core/services/api.service';
import { ServiceLocalStorage } from 'src/app/core/services/local-storage.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { AreaComponent } from '../area/area.component';
import * as L from 'leaflet';
import 'leaflet-routing-machine';
import 'leaflet-fullscreen';
import 'leaflet-draw';
import { Constants } from 'src/app/core/constants/constants';
import { MAPS_BASE_URL } from 'src/app/core/constants/maps.constants';
import { configureGoogleMapSearchAutocomplete } from 'src/app/core/utils/google-map-latlng-search.util';
declare let google: any;

@Component({
  selector: 'app-landmark',
  templateUrl: './landmark.component.html',
  styleUrls: ['./landmark.component.scss']
})
export class LandmarkComponent implements OnInit {

  public _mFormGroup: FormGroup;
  public mArea = new FormControl("", Validators.required);
  public mLandmarkName = new FormControl("", Validators.required);
  public mFormattedAddress = new FormControl("");
  public mLandmarkType = new FormControl("", Validators.required);
  isEditFlag: boolean = false;
  isOsm: boolean = false;
  showGoogleMap = false;
  googleMapInitialized = false;
  googleMapContentLoaded = false;
  mapLoadAttempts = 0;
  maxMapLoadAttempts = 50;
  mTitle: any;
  map: any;
  marker: any;
  directionsDisplay: any;
  directionsService: any;
  LandmarkRoute: any;
  landmarkTypes = []
  mAreaData: any[] = [];
  processOnSelect: any;
  allAreas: any[] = [];
  searchBox: any;
  showGoogleSearch = false;
  private googleSearchControlAttached = false;

  constructor(
    private fb: FormBuilder,
    private readonly apiService: ApiService,
    private notifyService: NotificationService,
    private ngxLoader: NgxUiLoaderService,
    private serviceLocalStorage: ServiceLocalStorage,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<LandmarkComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.mArea.valueChanges.subscribe(searchValue => {
      const sourceAreas = this.allAreas.length > 0 ? this.allAreas : data.area;
      this.mAreaData = searchValue
        ? sourceAreas.filter(area => area.area.toLowerCase().includes(searchValue))
        : sourceAreas;
    });

    this._mFormGroup = this.fb.group({
      landmarkName: this.mLandmarkName,
      area: this.mArea,
      formattedaddress: this.mFormattedAddress,
      landmarkType: this.mLandmarkType
    });

    this.mAreaData = data.area;
    this.isEditFlag = data.landmark.area != null;
    if (this.isEditFlag) {
      this.landmarkTypes = [
        { value: "C", viewValue: "Common point" },
        { value: "H", viewValue: "Home point" }
      ];
      this.mTitle = "Edit APL";
    } else {
      this.landmarkTypes = [{ value: "C", viewValue: "Common point" }];
      this.mTitle = "Add APL";
      this.mLandmarkType.setValue("C");
    }
    this.mLandmarkType.disable();
  }

  ngOnInit() {
    // this.showGoogleMap = this.serviceLocalStorage.isSetGoogleMapTypeEnabled();
    // setTimeout(() => {
    //   // if (Constants.OSRM === this.serviceLocalStorage.getMapType()) {
    //   //   this.isOsm = true;x
    //   //   this.loadOsmap();
    //   // } else {
    //   //   this.isOsm = false;
    //   //   this.directionsDisplay = new google.maps.DirectionsRenderer({
    //   //     suppressMarkers: true
    //   //   });
    //   //   this.directionsService = new google.maps.DirectionsService();
    //   //   this.loadgmap();
    //   // }
    //   if (this.showGoogleMap) {
    //     this.isOsm = false;
    //     // this.directionsDisplay = new google.maps.DirectionsRenderer({
    //     //   suppressMarkers: true
    //     // });
    //     // this.directionsService = new google.maps.DirectionsService();
    //     this.loadgmap();
    //   } else {
    //     this.isOsm = true;
    //     this.loadOsmap();
    //   }
    // }, 0);
    this.resolveMapTypeAndInit();
  }

  /** Uses client master-config flag (same as trip-map / master-routing). */
  private resolveMapTypeAndInit(): void {
    const clientCode = localStorage.getItem('clientCode');
    if (!clientCode) {
      this.initMapByClientFlag();
      return;
    }
    this.apiService.doGetRequestWithResponse(
      ApiConstants.getMapType + clientCode,
      success => {
        if (success.status === 200) {
          this.serviceLocalStorage.setGoogleMapTypeEnabled(!!success.body?.isGoogleMapEnabled);
        }
        this.initMapByClientFlag();
      },
      () => this.initMapByClientFlag()
    );
  }

  private initMapByClientFlag(): void {
    this.showGoogleMap = this.serviceLocalStorage.isSetGoogleMapTypeEnabled();
    this.isOsm = !this.showGoogleMap;
    this.googleMapInitialized = false;
    this.googleMapContentLoaded = false;
    this.mapLoadAttempts = 0;
    setTimeout(() => {
      if (this.showGoogleMap) {
        this.loadgmap();
      } else {
        this.loadOsmap();
      }
    }, 0);
  }

  onClickCancel(): void {
    this.dialogRef.close();
  }

  loadOsmap() {
    const { latitude, longitude } = this.data.site.landmark;
    this.map = L.map("apl-map", { fullscreenControl: true, dragging: true })
      .setView([latitude, longitude], 13);
    L.tileLayer(Constants.OSM_TILE, { attribution: Constants.OSM_CONTRIBUTORS }).addTo(this.map);
    this.map.addControl(new L.Control.Search(Constants.OSM_NOMINATIM_Obj));
    this.loadOSMap1();
    if (this.isEditFlag) {
      const landmark = this.data.landmark;
      this.mArea.setValue(landmark.area.area);
      this.processOnSelect = landmark.area;
      this.mLandmarkType.setValue(landmark.type);
      this.mLandmarkName.setValue(landmark.landmark);
      this.mFormattedAddress.setValue(landmark.formattedAddress);
      this.setMarker(L.latLng(landmark.latitude, landmark.longitude), true);
    }
    this.plotSite();
    this.showBoundaries();
  }

  loadOSMap1() {
    this.map.on("click", e => {
      const latLong = { lat: e.latlng.lat, lng: e.latlng.lng };
      if (this.marker) {
        this.marker.setLatLng(L.latLng(e.latlng.lat, e.latlng.lng));
      }
      this.getOSGeoLocation1(latLong);
    });
  }

  getOSGeoLocation1(latlng: any) {
    let url = `${MAPS_BASE_URL}/nominatim/reverse?lat=${latlng.lat}&lon=${latlng.lng}&zoom=-4&addressdetails=1&format=json`;
    this.apiService.doGetForOsm(url, (success) => {
      this.mLandmarkName.setValue(success.display_name);
      this.mFormattedAddress.setValue(success.display_name);
      if (success) {
        let latLong = {
          lat: success.lat,
          lng: success.lon
        };
        this.setMarker(latLong, false);
      }
      this.showBoundaries();
    }, error => {
    });
  }

  // loadgmap() {
  //   if (typeof google === 'undefined' || !google.maps?.Map) {
  //     setTimeout(() => this.loadgmap(), 100);
  //     return;
  //   }
  //
  //   const { latitude, longitude } = this.data.site.landmark;
  //   this.map = new google.maps.Map(document.getElementById("apl-map"), {
  //     center: { lat: latitude, lng: longitude },
  //     zoom: 12,
  //     draggable: true,
  //     zoomControl: true
  //   });
  //
  //   this.directionsDisplay = new google.maps.DirectionsRenderer({
  //     suppressMarkers: true,
  //     polylineOptions: { strokeWeight: 3, strokeColor: '#000', strokeOpacity: 0.7 }
  //   });
  //   this.directionsService = new google.maps.DirectionsService();
  //   this.directionsDisplay.setMap(this.map);
  //
  //   if (this.isEditFlag) {
  //     const landmark = this.data.landmark;
  //     this.setMarker(new google.maps.LatLng(landmark.latitude, landmark.longitude), true);
  //     this.mArea.setValue(landmark.area.area);
  //     this.processOnSelect = landmark.area;
  //     this.mLandmarkType.setValue(landmark.type);
  //     this.mLandmarkName.setValue(landmark.landmark);
  //     this.mFormattedAddress.setValue(landmark.formattedAddress);
  //   }
  //   this.plotSite();
  //   this.showBoundaries();
  // }

  loadgmap(afterInit?: () => void) {
    if (!this.showGoogleMap) {
      return;
    }
    if (this.googleMapInitialized && this.map?.setCenter) {
      this.onGoogleMapReady();
      afterInit?.();
      return;
    }
    const mapEl = document.getElementById('apl-map');
    if (!mapEl) {
      this.scheduleGoogleMapLoadRetry(afterInit);
      return;
    }
    if (typeof google === 'undefined' || (!google.maps?.Map && !google.maps?.importLibrary)) {
      this.scheduleGoogleMapLoadRetry(afterInit);
      return;
    }
    this.initGoogleMapAsync(mapEl, afterInit);
  }

  private scheduleGoogleMapLoadRetry(afterInit?: () => void): void {
    if (++this.mapLoadAttempts >= this.maxMapLoadAttempts) {
      afterInit?.();
      return;
    }
    setTimeout(() => this.loadgmap(afterInit), 100);
  }

  private async initGoogleMapAsync(mapEl: HTMLElement, afterInit?: () => void): Promise<void> {
    if (this.googleMapInitialized && this.map?.setCenter) {
      this.onGoogleMapReady();
      afterInit?.();
      return;
    }
    try {
      const { latitude, longitude } = this.data.site.landmark;
      const mapCenter = { lat: Number(latitude), lng: Number(longitude) };
      let MapClass = google.maps?.Map;
      if (google.maps?.importLibrary) {
        const mapsLib = await google.maps.importLibrary('maps') as any;
        MapClass = mapsLib.Map;
      }
      if (!MapClass) {
        this.scheduleGoogleMapLoadRetry(afterInit);
        return;
      }
      this.map = new MapClass(mapEl, {
        center: mapCenter,
        zoom: 12,
        draggable: true,
        zoomControl: true,
        gestureHandling: 'greedy'
      });
      this.googleMapInitialized = true;
      google.maps.event.addListenerOnce(this.map, 'idle', () => {
        google.maps.event.trigger(this.map, 'resize');
        this.map.setCenter(mapCenter);
        this.onGoogleMapReady();
        afterInit?.();
      });
    } catch (error) {
      console.error('Google Map init failed', error);
      this.scheduleGoogleMapLoadRetry(afterInit);
    }
  }

  private onGoogleMapReady(): void {
    if (this.googleMapContentLoaded || !this.map?.setCenter) {
      return;
    }
    this.googleMapContentLoaded = true;
    this.directionsDisplay = new google.maps.DirectionsRenderer({
      suppressMarkers: true,
      polylineOptions: { strokeWeight: 3, strokeColor: '#000', strokeOpacity: 0.7 }
    });
    this.directionsService = new google.maps.DirectionsService();
    this.directionsDisplay.setMap(this.map);

    // Same as OSM loadOSMap1 — allow selecting a point anywhere on the map
    this.map.addListener('click', (event: any) => {
      if (!event?.latLng) {
        return;
      }
      this.handleGoogleMapSelect(event.latLng);
    });

    if (this.isEditFlag) {
      const landmark = this.data.landmark;
      this.setMarker(new google.maps.LatLng(Number(landmark.latitude), Number(landmark.longitude)), true);
      this.mArea.setValue(landmark.area.area);
      this.processOnSelect = landmark.area;
      this.mLandmarkType.setValue(landmark.type);
      this.mLandmarkName.setValue(landmark.landmark);
      this.mFormattedAddress.setValue(landmark.formattedAddress);
    }
    this.plotSite();
    this.showBoundaries();
    this.googleSearchControlAttached = false;
    this.attachGoogleSearchControl('mr-al-google-search');
  }

  private attachGoogleSearchControl(elementId: string): void {
    if (!this.map?.controls || this.googleSearchControlAttached || !this.showGoogleMap) {
      return;
    }
    const searchEl = document.getElementById(elementId);
    if (!searchEl) {
      setTimeout(() => this.attachGoogleSearchControl(elementId), 50);
      return;
    }
    const position = google.maps.ControlPosition?.LEFT_TOP;
    this.map.controls[position].push(searchEl);
    this.googleSearchControlAttached = true;
  }

  openGoogleMapSearch(): void {
    if (!this.showGoogleMap) {
      return;
    }
    this.showGoogleSearch = true;
    this.searchBox = null;
    setTimeout(() => this.setupMapSearchBox(), 0);
  }

  closeGoogleMapSearch(): void {
    this.showGoogleSearch = false;
    this.searchBox = null;
  }

  /** Place/move marker + reverse-geocode + route (Google), like OSM map click. */
  private handleGoogleMapSelect(latLng: any): void {
    const lat = typeof latLng.lat === 'function' ? latLng.lat() : Number(latLng.lat);
    const lng = typeof latLng.lng === 'function' ? latLng.lng() : Number(latLng.lng);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
      return;
    }
    if (this.marker) {
      this.marker.setPosition(latLng);
      this.getGeoLocation(lat, lng);
      this.plotDirectionService(lat, lng);
    } else {
      this.getGeoLocation(lat, lng);
      this.setMarker(latLng, true);
    }
  }

  private async setupMapSearchBox(): Promise<void> {
    if (!this.showGoogleMap || !this.showGoogleSearch || this.searchBox || !this.map) {
      return;
    }
    let PlaceAutocompleteElementClass = (google.maps as any)?.places?.PlaceAutocompleteElement;
    if (google.maps?.importLibrary) {
      try {
        const placesLib = await google.maps.importLibrary('places') as any;
        PlaceAutocompleteElementClass = placesLib.PlaceAutocompleteElement;
      } catch (error) {
        console.error('Google Places library load failed', error);
      }
    }
    if (!PlaceAutocompleteElementClass) {
      if (this.showGoogleSearch) {
        setTimeout(() => this.setupMapSearchBox(), 100);
      }
      return;
    }
    const container = document.getElementById('mr-al-autocomplete');
    if (!container) {
      if (this.showGoogleSearch) {
        setTimeout(() => this.setupMapSearchBox(), 100);
      }
      return;
    }
    container.innerHTML = '';
    const autocompleteElement = new PlaceAutocompleteElementClass({
      includedRegionCodes: ['IN'],
      placeholder: 'Search Address'
    });
    container.appendChild(autocompleteElement);
    this.searchBox = configureGoogleMapSearchAutocomplete(
      autocompleteElement,
      coords => this.applyGoogleSearchLatLng(coords)
    );
    autocompleteElement.addEventListener('gmp-select', async (event: any) => {
      const prediction = event.placePrediction;
      if (!prediction) {
        return;
      }
      const place = prediction.toPlace();
      await place.fetchFields({
        fields: ['displayName', 'formattedAddress', 'location', 'viewport']
      });
      if (!place.location) {
        return;
      }
      this.handleGoogleMapSelect(place.location);
      if (place.formattedAddress) {
        this.mLandmarkName.setValue(place.formattedAddress);
        this.mFormattedAddress.setValue(place.formattedAddress);
      }
      if (place.viewport) {
        this.map.fitBounds(place.viewport);
      } else {
        this.map.setCenter(place.location);
        this.map.setZoom(17);
      }
      this.closeGoogleMapSearch();
    });
  }

  private applyGoogleSearchLatLng(coords: { lat: number; lng: number }): void {
    if (!this.map || !this.showGoogleMap) {
      return;
    }
    const location = new google.maps.LatLng(coords.lat, coords.lng);
    this.handleGoogleMapSelect(location);
    this.map.setCenter(location);
    this.map.setZoom(17);
    this.closeGoogleMapSearch();
  }

  plotSite() {
    let sitecordinates;
    var marker;
    let path = "./assets/images/company.png";
    if (this.isOsm) {
      sitecordinates = new L.latLng(this.data.site.landmark.latitude, this.data.site.landmark.longitude);
      marker = new L.marker(sitecordinates, {
        icon: new L.Icon({
          iconUrl: path,
          popupAnchor: [0, 10],
          iconSize: [40, 40],
          iconAnchor: [20, 40]
        })
      }).addTo(this.map).bindPopup(this.data.site.siteName);
    } else {
      sitecordinates = new google.maps.LatLng(this.data.site.landmark.latitude, this.data.site.landmark.longitude);
      var infowindow = new google.maps.InfoWindow({
        content: this.data.site.siteName
      });
      marker = new google.maps.Marker({
        position: sitecordinates,
        icon: {
          url: path,
          scaledSize: new google.maps.Size(40, 40)
        },
        map: this.map
      });
      google.maps.event.addListener(marker, "click", event => {
        infowindow.open(this.map, marker);
      });
    }
  }

  showBoundaries() {
    let boundary = this.data.site.boundary ? this.data.site.boundary : "";
    let path: any = [];
    let boundaryArr: any = boundary.split("),(");
    let polydata;
    if (this.isOsm) {
      boundaryArr.forEach(element => {
        if (element.includes("(")) element = element.split("(")[1];
        if (element.includes(")")) element = element.split(")")[0];
        path.push({
          lat: parseFloat(element.split(",")[0]),
          lng: parseFloat(element.split(",")[1])
        });
      });
      const editableLayers = new L.FeatureGroup();
      this.map.addLayer(editableLayers);
      polydata = new L.Control.Draw();
      editableLayers.addLayer(L.polygon(path));
      let latLong;
      editableLayers.on("click", e => {
        if (this.marker) {
          this.marker.setLatLng(L.latLng(e.latlng.lat, e.latlng.lng));
          latLong = {
            lat: this.marker._latlng.lat,
            lng: this.marker._latlng.lng
          };
          this.getOSGeoLocation(latLong);
          this.plotDirectionServiceOSM(this.marker._latlng.lat, this.marker._latlng.lng);
        } else {
          // this.mlat = e.latlng.lat;
          // this.mlng = e.latlng.lng;
          latLong = {
            lat: e.latlng.lat,
            lng: e.latlng.lng
          };
          this.getOSGeoLocation(latLong);
          this.setMarker(L.latLng(e.latlng), true);
        }
      });
    } else {
      boundaryArr.forEach(element => {
        if (element.includes("(")) element = element.split("(")[1];
        if (element.includes(")")) element = element.split(")")[0];
        let coordinates = new google.maps.LatLng(
          element.split(",")[0],
          element.split(",")[1]
        );
        path.push(coordinates);
      });
      let infoWindow = new google.maps.InfoWindow();
      if (path.length) {
        polydata = new google.maps.Polygon({
          paths: path,
          map: this.map,
          editable: false,
          strokeWeight: 1,
          fillColor: "#FFF176",
          clickable: true
        });
        // polydata.addListener("click", event => {
        //   if (this.marker) {
        //     this.marker.setPosition(event.latLng);
        //     this.getGeoLocation(this.marker.position.lat(), this.marker.position.lng());
        //     this.plotDirectionService(this.marker.position.lat(), this.marker.position.lng());
        //   } else {
        //     // this.mlat = event.latLng.lat();
        //     // this.mlng = event.latLng.lng();
        //     this.getGeoLocation(event.latLng.lat(), event.latLng.lng());
        //     this.setMarker(event.latLng, true);
        //   }
        // });
        polydata.addListener("click", event => {
          if (event?.latLng) {
            this.handleGoogleMapSelect(event.latLng);
          }
        });
        polydata.addListener("mousemove", event => {
          setTimeout(() => {
            infoWindow.close();
          }, 1000);
          infoWindow.setContent(this.data.site.siteName);
          infoWindow.setPosition(event.latLng);
        });
      }
    }
  }

  getOSGeoLocation(latlng: any) {
    // this.landmarkGeoLocating = true;
    if (navigator.geolocation) {
      // const control = new L.Control.Geocoder({ geocoder: null });
      // control.options.geocoder.reverse(latlng, 13, results => {
      //   this.landmarkGeoLocating = false;
      //   if (results.length > 0) {
      //     this.mLandmarkName.setValue(results[0].name);
      //     this.mFormattedAddress.setValue(results[0].name);
      //   } else {
      //     this.mLandmarkName.setValue('');
      //     this.mFormattedAddress.setValue('');
      //     this.notifyService.showInfo("No address available!", null);
      //   }
      // });
      let url = `${MAPS_BASE_URL}/nominatim/reverse?lat=${latlng.lat}&lon=${latlng.lng}&zoom=-4&addressdetails=1&format=json`;
      this.apiService.doGetForOsm(url, (success) => {
        // this.landmarkGeoLocating = false;
        this.mLandmarkName.setValue(success.display_name);
        this.mFormattedAddress.setValue(success.display_name);
      }, error => {
      });

    }
  }

  getGeoLocation(lat: number, lng: number) {
    // this.landmarkGeoLocating = true;
    // if (navigator.geolocation) {
    //   // let geocoder = new google.maps.Geocoder();
    //   // let latlng = new google.maps.LatLng(lat, lng);
    //   // let request = { latLng: latlng };
    //   // geocoder.geocode(request, (results, status) => {
    //   //   this.landmarkGeoLocating = false;
    //   //   if (status == google.maps.GeocoderStatus.OK) {
    //   //     let result = results[0];
    //   //     if (results.length > 0) {
    //   //       this.mLandmarkName.setValue(result.formatted_address);
    //   //       this.mFormattedAddress.setValue(result.formatted_address);
    //   //     } else {
    //   //       this.mLandmarkName.setValue('');
    //   //       this.mFormattedAddress.setValue('');
    //   //       alert("No address available!");
    //   //     }
    //   //   }
    //   // });
    //   let url = `${MAPS_BASE_URL}/nominatim/reverse?lat=${lat}&lon=${lng}&zoom=-4&addressdetails=1&format=json`;
    //   this.apiService.doGetForOsm(url, (success) => {
    //     // this.landmarkGeoLocating = false;
    //     this.mLandmarkName.setValue(success.display_name);
    //     this.mFormattedAddress.setValue(success.display_name);
    //   }, error => {
    //   });
    // }
    // Always reverse-geocode on select (same as OSM getOSGeoLocation1; do not require browser geolocation)
    let url = `${MAPS_BASE_URL}/nominatim/reverse?lat=${lat}&lon=${lng}&zoom=-4&addressdetails=1&format=json`;
    this.apiService.doGetForOsm(url, (success) => {
      // this.landmarkGeoLocating = false;
      this.mLandmarkName.setValue(success.display_name);
      this.mFormattedAddress.setValue(success.display_name);
    }, error => {
    });
  }

  setMarker(location, skipPlotDirection) {
    if (this.isOsm) {
      this.setNewOSMarker(location);
      if (skipPlotDirection) {
        this.plotDirectionServiceOSM(this.marker._latlng.lat, this.marker._latlng.lng);
      }
    } else {
      this.setNewMarker(location);
      this.plotDirectionService(this.marker.position.lat(), this.marker.position.lng());
    }
  }

  setNewMarker(location) {
    if (this.marker) {
      this.marker.setPosition(location);
      return;
    }
    this.marker = new google.maps.Marker({
      position: location,
      title: "Common Point",
      icon: {
        url: "./assets/images/marker_pin.png",
        scaledSize: new google.maps.Size(30, 30),
        anchor: new google.maps.Point(15, 30)
      },
      map: this.map,
      draggable: true
    });
    this.marker.addListener('dragend', (event: any) => {
      if (event?.latLng) {
        this.handleGoogleMapSelect(event.latLng);
      }
    });
  }

  setNewOSMarker(location) {
    this.marker = new L.marker(location, {
      icon: new L.Icon({
        iconUrl: "./assets/images/marker_pin.png",
        popupAnchor: [0, 0],
        iconSize: [30, 30],
        iconAnchor: [15, 30]
      })
    }).addTo(this.map).bindPopup("Common Point");
  }

  plotDirectionService(lat, lng) {
    this.directionsDisplay.setMap(null);
    this.directionsDisplay.setMap(this.map);
    const request = {
      origin: new google.maps.LatLng(lat, lng),
      destination: new google.maps.LatLng(
        this.data.site.landmark.latitude,
        this.data.site.landmark.longitude
      ),
      travelMode: google.maps.TravelMode.DRIVING,
      provideRouteAlternatives: true
    };
    this.directionsService.route(request, (response, status) => {
      if (status !== google.maps.DirectionsStatus.OK) {
        this.notifyService.showInfo("No route found to navigate!", null);
        return;
      }
      const shortestRoute = response.routes.reduce((shortest, route) =>
        route.legs[0].distance.value < shortest.legs[0].distance.value ? route : shortest
      , response.routes[0]);
      response.routes = [shortestRoute];
      this.directionsDisplay.setDirections(response);
    });
  }

  plotDirectionServiceOSM(lat, lng) {
    const wps = [L.latLng(lat, lng), L.latLng(this.data.site.landmark.latitude, this.data.site.landmark.longitude)];
    this.LandmarkRoute?.getPlan().setWaypoints([]);
    this.LandmarkRoute = L.Routing.control({
      serviceUrl: Constants.OSM_ROUTING_URL,
      waypoints: wps,
      showAlternatives: false,
      show: false,
      fitSelectedRoutes: true,
      waypointMode: "connect",
      addWaypoints: false,
      draggableWaypoints: false,
      autoRoute: true,
      reverseWaypoints: false,
      routeWhileDragging: false,
      createMarker: () => null,
      lineOptions: {
        styles: [{ color: "#000", weight: 3, opacity: 0.7 }]
      },
      altLineOptions: {
        styles: [{ color: "#ed6852", weight: 3 }]
      }
    }).addTo(this.map);
    this.LandmarkRoute.hide();
  }

  onAddArea(): void {
    const dialogRef = this.dialog.open(AreaComponent, {
      width: '300px',
      data: this.mAreaData,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.mArea.setValue("");
        this.apiService.doGetRequestWithResponse(
          ApiConstants.getAreaListByLocation + this.mAreaData[0].location.locationId,
          success => {
            if (success.status === 200) {
              this.allAreas = success.body;
            }
          },
          error => console.log(error)
        );
      }
    });
  }

  onSubmit() {
    if (!this.mArea.valid) {
      this.notifyService.showWarning("Please select area", null);
      return;
    }
    const getCoordinates = () => ({
      latitude: this.isOsm ? this.marker._latlng.lat : this.marker.position.lat(),
      longitude: this.isOsm ? this.marker._latlng.lng : this.marker.position.lng()
    });

    this.ngxLoader.start();
    if (this.isEditFlag) {
      const landmark = {
        ...this.data.landmark,
        area: this.processOnSelect,
        type: this.mLandmarkType.value,
        landmark: this.mLandmarkName.value,
        formattedAddress: this.mFormattedAddress.value,
        ...getCoordinates()
      };

      this.apiService.doPutRequestWithResponse(ApiConstants.addLandmark, landmark,
        success => {
          this.ngxLoader.stop();
          if (success.status === 200) {
            this.dialogRef.close(success);
            this.notifyService.showSuccess(success.body.message, null);
          } else {
            this.notifyService.showInfo("Landmark not found successfully!", null);
          }
        },
        error => {
          this.ngxLoader.stop();
          console.log(error);
        }
      );
    } else {
      const data = {
        area: this.processOnSelect,
        landmark: this.mLandmarkName.value,
        type: this.mLandmarkType.value,
        formattedAddress: this.mFormattedAddress.value,
        ...getCoordinates()
      };

      this.apiService.doPostRequestWithResponse(ApiConstants.addLandmark, data,
        success => {
          this.ngxLoader.stop();
          if (success.status === 201) {
            this.dialogRef.close(success);
            this.notifyService.showSuccess(success.body.message, null);
          }
        },
        error => {
          this.ngxLoader.stop();
          this.notifyService.showError(error.message, null);
        }
      );
    }
  }

  onAreaChange(searchData) {
    this.processOnSelect = searchData;
  }


}
